export const thumbnail_img =
  '//s3.marpple.co/files/u_218933/2024/7/original/66f2110040004cfe41d0a821b61d3e74e34582ce1.png';

export const banner_img =
  '//s3.marpple.co/files/u_218933/2024/6/original/6c4a81ee38c57b64c1f4c8522461276abb243ca41.png';

export const default_creator_img =
  '//s3.marpple.co/files/u_1165777/2024/4/original/8ff2b4e88ce4d2eabce1474c26a20de0220d2d981.png';

export const default_plus_img =
  '//s3.marpple.co/files/u_1165777/2024/4/original/8ff2b4e88ce4d2eabce1474c26a20de0220d2d981.png';

export const ad_seller_filter_type_name = '핸드메이드';

export const CREATOR_RANKING_MAX_DISPLAY_COUNT = 100;

export const CREATOR_RANKING_MONTHLY_REDIS_KEY = 'ranking:store:monthly';
export const CREATOR_RANKING_WEEKLY_REDIS_KEY = 'ranking:store:weekly';
export const CREATOR_RANKING_REALTIME_REDIS_KEY = 'ranking:store:realtime';
export const CREATOR_ALL_COUNT_REDIS_KEY = 'store:count:all';

export const NEW_CREATOR_RANKING_MONTHLY_REDIS_KEY = 'ranking:new-creator:monthly';

export const CREATOR_ALL_COUNT_EXPIRE_TIME = 60000 * 60;

export const CREATOR_ALL_SEARCH_CARD_COUNT = 90;

// crews_stores_store_labels 의 139 번은 테스트 계정 표식
// 언제든 달라질 수 있으니 싱크를 맞춰주어야 한다.
export const TEST_STORE_LABEL_ID = 139;
